<mat-form-field id="selectGEN-mat-form" [formGroup]="group" class="custom-form-field">
  <mat-label>{{ field.displayName }}</mat-label>
  <mat-select
    [formControlName]="field.name"
    [id]="field.name"
    [(ngModel)]="modeSelect"
    [required]="field?.isRequired"
    style="margin-top: 6px"
  >
    @for (item of field.options; track item) {
      <mat-option
        id="selectGEN-mat-form-option"
        [value]="item.key"
        (click)="onchange(item.value)"
        (keyup.enter)="onchange(item.value)"
        tabindex="0"
        >{{ item.value }}</mat-option
      >
    }
  </mat-select>
  @for (validation of field.validations; track validation) {
    <ng-container id="selectGEN-ng-container" ngProjectAs="mat-error">
      @if (group.get(field.name).hasError(validation.name)) {
        <mat-error id="selectGEN-mat-form-error{{ field.name }}">{{ validation.message }}</mat-error>
      }
    </ng-container>
  }
</mat-form-field>
